import { render, staticRenderFns } from "./DeliveryAddressNewGiftInformation.vue?vue&type=template&id=e0160a04&"
import script from "./DeliveryAddressNewGiftInformation.vue?vue&type=script&lang=js&"
export * from "./DeliveryAddressNewGiftInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports